import { render, staticRenderFns } from "./bigModal.vue?vue&type=template&id=c1a2a6f4"
import script from "./bigModal.vue?vue&type=script&lang=js"
export * from "./bigModal.vue?vue&type=script&lang=js"
import style0 from "./bigModal.vue?vue&type=style&index=0&id=c1a2a6f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports